import React, { Component } from 'react';
import { DragDropContainer } from 'react-drag-drop-container';
import CancelIcon from '@material-ui/icons/Cancel';

const parentStyle = {
  position: 'fixed',
  top: '20%', 
}

const removeBtnStyle = {
  position: 'absolute', 
  background: 'white', 
  right: 10,  
  top: -25, 
  borderRadius: 100,
  zIndex: 9,
  cursor: 'pointer'
}

const droppableStyle = {
  position: 'relative',
  zIndex: 9,
  display: 'inline-block',
  background: '#3f51b5',
  transition: '0.4s ease',
  color: '#ffffff',
  fontSize: 18,
  marginBottom: 20,
  marginRight: 20,
  padding: 10,
  fontWeight: 'bold',
  borderRadius: 4,
  border: '1px inset #3042a7'
}

class popularHours extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: true,
      }
    }

    componentDidMount() {
      this.setState({ isLoading: false });
    }

    handleDrop = (e) => {
      e.preventDefault();
      this.setState({ props: { ...this.state.props, defaultValue: e.target.value } }, function(){
        this.props.pushData(e);
      }) 
    }

    handleRemoveHour = (i, e) => {
      this.props.getTiming.splice(i, 1); 
      this.props.setHour();

      this.setState({ isLoading: true }, () => {
        this.setState({ isLoading: false })
      });
    }

    render() {
      return (
        ( this.state.isLoading === false ?
          <div>
            <h3>Popular Hours</h3>
            <hr/> 
            {
              this.props.getTiming.length < 1 ? <div className="alert alert-success" role="alert">{'Suggestions will appear here once we collected the popular hours used. You can easily Drag & Drop the timings to the left panel under the each day for faster data-entry.'}</div> : 
              this.props.getTiming.map((value, index) => {
              return  <div style={{ position: 'relative', display: 'inline' }} key={index + '_' + value.from + '-' + value.to}>
                        <DragDropContainer zIndex={9999} targetKey="timingOnly" key={index + '_' + value.from + '-' + value.to} dragClone dragData={{from: value.from, to: value.to}}>
                          <div style={droppableStyle}>{value.from} - {value.to}</div>
                        </DragDropContainer> 
                        <CancelIcon style={removeBtnStyle}  onClick={() => { this.handleRemoveHour(index, {from: value.from, to: value.to}) }}/>
                      </div>
              })
            }
          </div> : '' )
      ); 
    }
}

export default popularHours;